import React from 'react';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import Game from './components/Game';

const theme = extendTheme({
  styles: {
    global: {
      body: {
        bg: 'black',
        color: 'white',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'bold',
        borderRadius: 'md',
        _hover: {
          transform: 'translateY(-2px)',
          boxShadow: '0 0 15px rgba(0, 255, 255, 0.5)',
        },
      },
      variants: {
        solid: {
          bg: 'transparent',
          border: '2px solid',
          borderColor: 'cyan.400',
          color: 'cyan.400',
          _hover: {
            bg: 'cyan.400',
            color: 'black',
          },
        },
      },
    },
    Container: {
      baseStyle: {
        backdropFilter: 'blur(10px)',
        bg: 'rgba(0, 0, 0, 0.7)',
        borderRadius: 'xl',
        border: '1px solid',
        borderColor: 'cyan.400',
      },
    },
    Heading: {
      baseStyle: {
        color: 'cyan.400',
        textShadow: '0 0 10px rgba(0, 255, 255, 0.5)',
      },
    },
    Text: {
      baseStyle: {
        color: 'white',
      },
    },
  },
});

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Game />
    </ChakraProvider>
  );
}

export default App;
